import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CircleRegular from './circle-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CircleRegular {...validProps} />;
}

SvgComponent.iconName = 'circleRegular';

export const CircleRegularIcon = svgIconWrapper(SvgComponent);
